<template>
    <div>
        <section class="checkout-nav-section">
            <div class="checkoutnav_wrap">
                <div class="checkoutnav_div">
                    <a href="#" class="link-block-73 w-inline-block"><img src="@/assets/images/Main_Logo.png" loading="lazy" sizes="84.03125px" srcset="@/assets/images/Logo-p-500.png 500w, @/assets/images/Logo-p-800.png 800w, @/assets/images/Main_Logo.png 1000w" alt="" class="image-487"></a>
                    <div class="checkoutnav_progressdiv">
                        <div class="progress_step_div"></div>
                        <div class="progress_step_div current"></div>
                        <div class="progress_step_div"></div>
                        <div class="progress_step_div"></div>
                    </div>
                </div>
            </div>
        </section>
      <section class="checkout-section">
        <div class="checkoutb_wrap">
          <div class="checkoutb_div">
            <div class="almostdone-div">
              <div class="text-block-1151">Almost Done {{user.first_name}}!</div>
              <div class="text-block-1152">Our 100% digital process will ensure you can start your medical weightloss journey in as little as 3 days.</div>
              <div class="timeline-div">
                <div class="timeline_line"></div>
                <div class="linebullet_div"><img src="@/assets/images/icon_circle-icon.svg" loading="lazy" alt="" class="image-510">
                  <div>
                    <div class="text-block-1153"></div>
                    <div class="text-block-1154">Complete Medical Questionnaire</div>
                    <div class="text-block-1155">Fill out a short online form to submit to the doctor.</div>
                  </div>
                </div>
                <div class="linebullet_div"><img src="@/assets/images/icon_circle-icon.svg" loading="lazy" alt="" class="image-510">
                  <div>
                    <div class="text-block-1153"></div>
                    <div class="text-block-1154">Doctor Review &amp; Prescription</div>
                    <div class="text-block-1155">You will meet with your assigned doctor either through video call or online chat dependent upon your state of residence and your medical history. If approved you will receive an instant notification.</div>
                  </div>
                </div>
                <div class="linebullet_div"><img src="@/assets/images/icon_circle-icon.svg" loading="lazy" alt="" class="image-510">
                  <div>
                    <div class="text-block-1153"></div>
                    <div class="text-block-1154">Our Pharmacy Processes Your Order</div>
                    <div class="text-block-1155">Our State Board Approved 503A Pharmacies will process your order within 24-48 hours (Mon-Thursday). All orders processed on Friday will be shipped on Monday the following week.</div>
                  </div>
                </div>
                <div class="linebullet_div"><img src="@/assets/images/icon_circle-icon.svg" loading="lazy" alt="" class="image-510">
                  <div>
                    <div class="text-block-1153"></div>
                    <div class="text-block-1154">FREE Overnight Cold Shipping</div>
                    <div class="text-block-1155">You can track the packages and get updates directly in our portal.</div>
                  </div>
                </div>
              </div>
              <div class="almost_bottomflex_div">
                <div><img src="@/assets/images/stepsimage_teledoc_PM-p-500.png" loading="lazy" sizes="(max-width: 479px) 17vw, 74.5625px" srcset="@/assets/images/stepsimage_teledoc_PM-p-500.png 500w, @/assets/images/stepsimage_teledoc_PM-p-500.png 641w" alt="" class="image-511"></div>
                <p class="paragraph-153">During this time you can access our Medical Weight Loss Biohacking Guide to help you prepare prior to receiving medication.</p>
              </div>
              <div class="almost-button-div">
                <a href="#" class="button-109 w-button" @click="pushToMedForm()">Complete Medical Form <span class="text-span-247">-&gt;</span></a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    </template>
    <script>
    
    import { mapGetters } from 'vuex';
    export default {
        name: 'paymentThanks',
        props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
        data() {
            return {
                active_el: 1,
                selectedOption:'',
                submitting: false,
            }
        },
        computed:{
            ...mapGetters(['getRemainingPrescriptions','user']),
            remainingPrescriptions() {
                return this.getRemainingPrescriptions;
            },
            getDrugName(){
                return this.selectedOption === '' ? 'GLP Anti-Nausea and GLP Energy' : this.selectedOption === 'B12' ? 'GLP Anti-Nausea' : 'GLP Energy'
            },
            getProductName(){
                return JSON.parse(localStorage.getItem("planName"))
            }
        },
        watch: {
            active_el() {
                window.scrollTo(0, 0)
            }
        },
        methods:{
         
            setMedSelected(value){
                this.selectedOption = value;
                this.moveToNext();
            },
            moveToNext(){
                this.active_el=2;
            },
            async sendRequest(product){
              let response = await this.$axios.post(`${this.baseUrl}/api/bundle-selected`, {
                  selectedMed: product
              });
              return response;
            },
            async addBundleAndMove(){
                this.submitting = true;
                if(this.selectedOption!=''){
                    let response = await this.sendRequest(this.selectedOption);
                    console.log(response)
                    this.active_el=3;
                }else{
                  let response = await this.sendRequest("None");
                  console.log(response)
                  this.active_el=3;
                }
                
            },
            pushToMedForm(){
              this.$router.push({
                        name: 'verifyPhoneAndEmail'
              });
            }
        },
        mounted(){
            console.log(this.remainingPrescriptions)
            
        }
    }
    </script>
    <style scoped>
    .selected-plan-img{
        width: 45px;
    }
    </style>